var map = {
	"./0.png": "5753",
	"./1.png": "0820",
	"./2.png": "5ebc",
	"./3.png": "3ed5",
	"./4.png": "e60e",
	"./5.png": "6b35",
	"./6.png": "8f7d",
	"./7.png": "68bc",
	"./8.png": "9d96",
	"./9.png": "8bd8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4257";